import { render } from "./YourInfo.vue?vue&type=template&id=0cc12f22&scoped=true"
import script from "./YourInfo.vue?vue&type=script&lang=js"
export * from "./YourInfo.vue?vue&type=script&lang=js"

import "./YourInfo.vue?vue&type=style&index=0&id=0cc12f22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cc12f22"]])

export default __exports__